export const SITE = {
  name: 'Impact Academy',
  shortName: 'IMAC',
  tagline: { en: 'Excellence in Concours Preparation', fr: 'Excellence en Préparation aux Concours' },
  description: {
    en: "Cameroon's leading prep class for ENS, ENAM, ENSET, FET, COT, COLTECH, FMSB and other competitive concours. Three centers in Limbe.",
    fr: "La principale école de préparation au Cameroun pour ENS, ENAM, ENSET, FET, COT, COLTECH, FMSB et autres concours compétitifs. Trois centres à Limbé.",
  },
  url: 'https://imacprepa.org',
  email: 'info@imacprepa.org',
  centers: [
    { name: 'Mile 4 Center', address: 'Government Primary School Mile 4, Limbe' },
    { name: 'PYC Half Center', address: 'PYC Half, Limbe' },
    { name: 'Isokolo Center', address: 'Isokolo, Limbe' },
  ],
  socials: {
    facebook: '',
    instagram: '',
    tiktok: '',
    linkedin: '',
    youtube: '',
    twitter: '',
  },
};

export const WHATSAPP_DEPARTMENTS = [
  {
    key: 'engineering',
    label: { en: 'Engineering Department', fr: 'Département Ingénierie' },
    role: { en: 'Head of Engineering', fr: "Chef de l'Ingénierie" },
    number: '237678708736',
    icon: 'Cpu',
  },
  {
    key: 'meds',
    label: { en: 'Medical Department', fr: 'Département Médical' },
    role: { en: 'Head of Meds Department', fr: 'Chef du Département Médical' },
    number: '237676561727',
    icon: 'Stethoscope',
  },
  {
    key: 'operations',
    label: { en: 'Operations / Admissions', fr: 'Opérations / Admissions' },
    role: { en: 'Operations', fr: 'Opérations' },
    number: '237670951934',
    icon: 'Building2',
  },
];

export const buildWhatsAppUrl = (number, message = '') => {
  const text = message ? `?text=${encodeURIComponent(message)}` : '';
  return `https://wa.me/${number}${text}`;
};

// WhatsApp group invite link for alumni — replace when the user provides it.
export const ALUMNI_WHATSAPP_GROUP = 'https://chat.whatsapp.com/KlRljsT2pUKHFY80tHHI0V';

// Cloudinary configuration. Cloud name is hardcoded here so the site works
// without an .env file in dev. The unsigned upload preset is read from env
// for the (future) admin uploader; not needed for read-only delivery.
export const CLOUDINARY = {
  cloudName: import.meta.env?.VITE_CLOUDINARY_CLOUD_NAME || 'dcu27flt1',
  uploadPreset: import.meta.env?.VITE_CLOUDINARY_UPLOAD_PRESET || 'imac_unsigned',
};

// Map a program type/id → which dept handles inquiries.
// Default: operations (admissions). Engineering/medical programs route to their heads.
export const PROGRAM_DEPT_ROUTING = {
  medical: 'meds',
  fmsb: 'meds',
  fhs: 'meds',
  engineering: 'engineering',
  enset: 'engineering',
  polytechnique: 'engineering',
  ensp: 'engineering',
  iut: 'engineering',
};

export const getDeptForProgram = (program) => {
  if (!program) return WHATSAPP_DEPARTMENTS[2];
  const key = (program.type || program.id || '').toLowerCase();
  const deptKey = PROGRAM_DEPT_ROUTING[key] || 'operations';
  return WHATSAPP_DEPARTMENTS.find((d) => d.key === deptKey) || WHATSAPP_DEPARTMENTS[2];
};

export const formatPhoneDisplay = (number) => {
  const n = number.replace(/\D/g, '');
  if (n.startsWith('237') && n.length === 12) {
    return `+237 ${n.slice(3, 6)} ${n.slice(6, 9)} ${n.slice(9)}`;
  }
  return `+${n}`;
};
